export default function ToolsHostingStep({ onNext, onBack }) {
  return (
    <>
      <h3>Tools & Data Hosting</h3>

      <label>Project Execution Tools</label>
      <select>
        <option>Client Provided</option>
        <option>Basic Microsoft Products</option>
        <option>Discuss with 1OPSS</option>
      </select>

      <label>Data Hosting</label>
      <select>
        <option>Client Provided</option>
        <option>Agreed Upon</option>
      </select>

      <div className="actions">
        <button className="btn secondary" onClick={onBack}>Back</button>
        <button className="btn primary" onClick={onNext}>Next</button>
      </div>
    </>
  );
}
